// axiosInstance.js

import axios from "axios";
import { getBaseURL } from "@/app/global-functions/baseURLUtils-administrators";

const baseURL = getBaseURL();
let currentDomain = "";

if (typeof window !== "undefined") {
  currentDomain = window.location.hostname;
}

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    "Accept": "application/json",
    "X-App-Domain": currentDomain,
  },
  withCredentials: true,
});

const getAuthToken = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("authToken");
  }
  return "";
};

axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default axiosInstance;

// A helper function to add the response interceptor later:
export const addResponseInterceptor = (router) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (typeof window !== "undefined" && error.response && error.response.status === 401) {
        localStorage.removeItem("authToken");
        router.push("/login");  // Use router from component
      }
      return Promise.reject(error);
    }
  );
};